<template>
  <div class="mod-rm__coursevehiclerela">

    <div style="margin-top: 5px;">
      <el-row :gutter="10">
        <!--查询车辆-->
        <el-col>
          <el-card class="box-card">
            <el-row>
              <el-col>
                <div ref="queryBox"
                     class="queryBox">
                  <el-form :label-width="queryLabelWidth"
                           @submit.native.prevent
                           @keyup.enter.native="query()"
                           :model="dataForm">
                    <el-row style="height: 20px">
                      <!-- 关键词 -->
                      <el-col :span="5">
                        <el-tooltip content="请输入车型分类/VIN/发动机型号/标签"
                                    placement="bottom"
                                    effect="light">
                          <el-input v-model="dataForm.keyWords"
                                    :placeholder="$t('scheduling.KeyWord')"
                                    class="startTime-label"
                                    clearable></el-input>
                        </el-tooltip>
                      </el-col>
                      <!-- 选择时间 -->
                      <el-col :span="8">
                        <el-form-item :label="$t('scheduling.timeSlot')"
                                      class="startTime-label removeX"
                                      style="width: 100% !important;"
                                      :required="true">
                          <el-date-picker v-model="dataForm.startTime"
                                          type="date"
                                          value-format="yyyy-MM-dd 00:00:00"
                                          placeholder="选择开始日期时间"
                                          :clearable="false"
                                          @change="dataUpdate"
                                          style="width: 98% !important;">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-date-picker v-model="dataForm.endTime"
                                        class="startTime-label removeX"
                                        type="date"
                                        value-format="yyyy-MM-dd 23:59:59"
                                        placeholder="选择结束日期时间"
                                        @change="dataUpdate"
                                        style="width: 90% !important;">
                        </el-date-picker>
                      </el-col>
                      <el-col :span="5">
                        <el-button style="margin-bottom: 7px;float: right;"
                                   type="primary"
                                   :loading="dataListLoading"
                                   @click="query()">{{ $t('query') }}</el-button>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-col>
            </el-row>
            <div class="search">
              <!-- 确定按钮 -->
              <el-button style="margin-bottom: 7px"
                         type="primary"
                         @click="onOk">{{ $t('trainer.define') }}</el-button>
            </div>
            <!-- 数据网格 -->
            <el-collapse v-model="activeName"
                         accordion>
              <!-- 可调配资源 -->
                <el-collapse-item class="hidden_i_recourse" name="1">
                  <template slot="title">
                    <div @click="moreList2 = !moreList2">
                      <em v-bind:class="{ 'el-icon-caret-bottom': moreList2, 'el-icon-caret-right': !moreList2 }">分组1：可调配资源</em>
                    </div>
                  </template>
                  <!--可调配资源table-->
                  <el-table :data="allocateVehicleList"
                            ref="coursePlanTable"
                            class="jySelectionAll"
                            border
                            stripe
                            @select="selectRedio"
                            v-loading="dataListLoading"
                            :show-header="true"
                            style="width: 100%;"
                            height="300">
                    <el-table-column type="selection"
                                     header-align="center"
                                     align="center"
                                     width="50"></el-table-column>
                    <!-- 车型分类 -->
                    <el-table-column prop="vehicleClass"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.vehicleType')">
                    </el-table-column>
                    <!-- 车辆分类 -->
                    <el-table-column prop="vehicleClassId"
                                     header-align="center"
                                     align="center"
                                     :formatter="vehicleClassFormatter"
                                     show-overflow-tooltip
                                     :label="$t('res.vehinfo.vehicleClassification')">
                    </el-table-column>
                    <!-- 品牌 -->
                    <el-table-column prop="brand"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.brand')">
                    </el-table-column>
                    <!-- VIN -->
                    <el-table-column prop="chassisNo"
                                     header-align="center"
                                     align="center"
                                     width="150"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.vin')">
                      <template slot-scope="scope">
                        <el-button size="mini"
                                   type="text"
                                   @click="Update(scope.row)">{{scope.row.chassisNo}}</el-button>
                      </template>
                    </el-table-column>
                    <!-- 所属公司 -->
                    <el-table-column prop="belongCompanyNameZH"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.affiliatedCompany')">
                    </el-table-column>
                    <!-- 所属站点 -->
                    <el-table-column prop="subordinateSite"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.affiliatedSites')">
                    </el-table-column>
                    <!--发动机型号-->
                    <el-table-column prop="engineModel"
                                     header-align="center"
                                     align="center"
                                     width="120"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.engineModel')">
                    </el-table-column>
                    <!--利用率-->
                    <el-table-column prop="utilizationRate"
                                     header-align="center"
                                     align="center"
                                     :label="$t('vehicle.utilizationRatio')">
                    </el-table-column>
                    <!-- 年度目标 -->
                    <el-table-column prop="reportAnnualTarget"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.annualTarget')">
                    </el-table-column>
                    <!-- 优先级 -->
                    <el-table-column prop="priority"
                                     header-align="center"
                                     align="center"
                                     :label="$t('vehicle.priority')">
                    </el-table-column>
                    <!-- 车辆池 -->
                    <el-table-column prop="poolName"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.vehiclePool')">
                    </el-table-column>
                    <!-- 车辆池备注 -->
                    <el-table-column prop="poolRemarks"
                                     header-align="center"
                                     align="center"
                                     width="120"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.vehiclePoolRemarks')">
                    </el-table-column>
                    <!-- 标签 -->
                    <el-table-column header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('res.vehinfo.label')">
                      <template slot-scope="scope">
                        <!--查看-->
                        <span class="el-dropdown-link"
                              v-if="scope.row.number !== null"
                              @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
                      </template>
                    </el-table-column>
                    <!-- 备注 -->
                    <el-table-column prop="remarks"
                                     header-align="center"
                                     align="center"
                                     show-overflow-tooltip
                                     :label="$t('vehicle.remarks')">
                    </el-table-column>
                    <!-- 本场地台数 -->
                    <el-table-column prop="classQuaty"
                                     header-align="center"
                                     align="center"
                                     width="120"
                                     show-overflow-tooltip
                                     :label="$t('vehicleAllocation.classQuaty')">
                    </el-table-column>
                    <!-- 预计始发地 -->
                    <el-table-column prop="planOriginalPlace"
                                     header-align="center"
                                     align="center"
                                     width="120"
                                     show-overflow-tooltip
                                     :label="$t('vehicleAllocation.planOriginalPlace')">
                    </el-table-column>
                  </el-table>
                  <el-pagination @size-change="allPageSizeChangeHandle"
                                 @current-change="allPageCurrentChangeHandle"
                                 :current-page="dataForm.allPage"
                                 :page-sizes="[10, 20]"
                                 :page-size="dataForm.allLimit"
                                 layout="total, sizes, prev, pager, next, jumper"
                                 :total="allocateVehicleListTotal">
                  </el-pagination>
                </el-collapse-item>
            </el-collapse>
            <!-- 已占用资源 -->
            <el-collapse accordion>
              <el-collapse-item class="hidden_i_recourse">
                <template slot="title">
                  <div @click="moreList3 = !moreList3">
                    <em v-bind:class="{ 'el-icon-caret-bottom': moreList3, 'el-icon-caret-right': !moreList3 }">分组2：已占用资源</em>
                  </div>
                </template>
                <!--占用资源table-->
                <el-table :data="enableVehicleList"
                          ref="tableRef3"
                          border
                          stripe
                          class="change_title_background"
                          v-loading="dataListLoading"
                          :show-header="true"
                          style="width: 100%;"
                          height="300">
                  <el-table-column header-align="center"
                                   align="center"
                                   width="50"></el-table-column>
                  <!-- 车型分类 -->
                  <el-table-column prop="vehicleClass"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.vehicleType')">
                  </el-table-column>
                  <!-- 车辆分类 -->
                  <el-table-column prop="vehicleClassId"
                                   header-align="center"
                                   align="center"
                                   :formatter="vehicleClassFormatter"
                                   show-overflow-tooltip
                                   :label="$t('res.vehinfo.vehicleClassification')">
                  </el-table-column>
                  <!-- 品牌 -->
                  <el-table-column prop="brand"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.brand')">
                  </el-table-column>
                  <!-- VIN -->
                  <el-table-column prop="chassisNo"
                                   header-align="center"
                                   align="center"
                                   width="150"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.vin')">
                    <template slot-scope="scope">
                      <el-button size="mini"
                                 type="text"
                                 @click="Update(scope.row)">{{scope.row.chassisNo}}</el-button>
                    </template>
                  </el-table-column>
                  <!-- 所属公司 -->
                  <el-table-column prop="belongCompanyNameZH"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.affiliatedCompany')">
                  </el-table-column>
                  <!-- 所属站点 -->
                  <el-table-column prop="subordinateSite"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.affiliatedSites')">
                  </el-table-column>
                  <!--发动机型号-->
                  <el-table-column prop="engineModel"
                                   header-align="center"
                                   align="center"
                                   width="120"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.engineModel')">
                  </el-table-column>
                  <!--利用率-->
                  <el-table-column prop="utilizationRate"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.utilizationRatio')">
                  </el-table-column>
                  <!-- 年度目标 -->
                  <el-table-column prop="reportAnnualTarget"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.annualTarget')">
                  </el-table-column>
                  <!-- 优先级 -->
                  <el-table-column prop="priority"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.priority')">
                  </el-table-column>
                  <!-- 车辆池 -->
                  <el-table-column prop="poolName"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.vehiclePool')">
                  </el-table-column>
                  <!-- 车辆池备注 -->
                  <el-table-column prop="poolRemarks"
                                   header-align="center"
                                   align="center"
                                   width="120"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.vehiclePoolRemarks')">
                  </el-table-column>
                  <!-- 标签 -->
                  <el-table-column header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('res.vehinfo.label')">
                    <template slot-scope="scope">
                      <!--查看-->
                      <span class="el-dropdown-link"
                            v-if="scope.row.number !== null"
                            @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
                    </template>
                  </el-table-column>
                  <!-- 备注 -->
                  <el-table-column prop="remarks"
                                   header-align="center"
                                   align="center"
                                   show-overflow-tooltip
                                   :label="$t('vehicle.remarks')">
                  </el-table-column>
                </el-table>
                <el-pagination @size-change="enaPageSizeChangeHandle"
                               @current-change="enaPageCurrentChangeHandle"
                               :current-page="dataForm.enaPage"
                               :page-sizes="[10, 20]"
                               :page-size="dataForm.enaLimit"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="enableVehicleListTotal">
                </el-pagination>
              </el-collapse-item>
            </el-collapse>
            <scheduling-div :schedulingName="vehicleName"
                            ref="vehicleDivRef"></scheduling-div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- 标签查看 -->
    <el-dialog title="标签查看"
               :visible="isShowLable"
               width="70%"
               :before-close="showLableClose"
               :modal-append-to-body='false'
               append-to-body>
      <el-form label-position="top"
               label-width="150px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow = "false"
                     :closeShow = "false"
                     :bussinessTypeId = "bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import Tag from '@/components/rm/label-select/index'
  import SchedulingDIV from '@/components/rm/resouce-select/schedulingDiv.vue'
  import VueI18n from '@/i18n'
  import Vue from 'vue'
  export default {
    props: [
      // 时间 起
      'startTime',
      // 时间 止
      'endTime',
      // 场地id
      'siteId'
    ],
    data () {
      return {
        vehicleName: '车辆日程安排',
        isShowHead: false,
        moreList2: true,
        moreList3: false,
        activeName: '1',
        activeName2: '2',
        activeName3: '3',
        startDate: new Date(this.startTime.replace(/-/g, '/')),
        endDate: new Date(this.endTime),
        dataForm: {
          keyWords: '',
          siteId: '',
          startTime: '',
          endTime: '',
          type: 'V',
          queryType : '0',
          ablePage: 1, // 当前页码
          ableLimit: 10, // 每页数
          allPage: 1, // 当前页码
          allLimit: 10, // 每页数
          enaPage: 1, // 当前页码
          enaLimit: 10, // 每页数
        },

        total: 0, // 总条数deleteURL
        ableVehicleListTotal: 0,
        allocateVehicleListTotal: 0,
        enableVehicleListTotal: 0,
        checkList: [],
        // 模块id，20 代表组织管理模块
        moduleId: '20',
        bussinessTypeId: 9,
        bussinessTypeChecked: null,
        isShowLable: false,
        // 查询面板标签宽度
        queryLabelWidth: '85px',
        ableVehicleList: [],
        allocateVehicleList: [],
        enableVehicleList: [],
        dataListLoading: false,
        schedulingDiv: {
          id: '',
          roomCnAbbr: ''
        }
        // startTimeVali: this.beginDate(),
        // endTimeVali: this.endTimeDate()
      }
    },
    components: {
      Tag,
      'scheduling-div': SchedulingDIV
    },
    mounted () {
      this.$nextTick(() => {
        this.initMethod()
      })
      this.$eventHub.$on('vehicle_class_call', (data) => {
        this.initMethod()
      })
    },
    updated () {
      this.$eventHub.$on('select_vehicleUpdate_wxl', (data, dataForm) => {
        this.$refs.vehicleDivRef && this.$refs.vehicleDivRef.queryScheduling(data, dataForm)
      })
    },
    methods: {
      // 正整数的正则表达式
      isPositiveInteger (s) {
        let re = /^\d+(\.\d+)?$/
        return re.test(s)
      },
      beginDate: function beginDate () {
        let _this = this
        return {
          disabledDate: function disabledDate (time) {
            if (_this.dataForm.endTime) {
              return time.getTime() < new Date(_this.startTime).getTime() - 1 * 24 * 60 * 60 * 1000 || time.getTime() > new Date(_this.dataForm.endTime).getTime()
            }
            return time.getTime() < new Date(_this.startTime).getTime() - 1 * 24 * 60 * 60 * 1000 || time.getTime() > new Date(_this.endTime).getTime()
          }
        }
      },
      endTimeDate: function endTimeDate () {
        let _this = this
        return {
          disabledDate: function disabledDate (time) {
            if (_this.dataForm.startTime) {
              return time.getTime() < new Date(_this.dataForm.startTime).getTime() - 1 * 24 * 60 * 60 * 1000 || time.getTime() > new Date(_this.endTime).getTime()
            }
            return time.getTime() < new Date(_this.startTime).getTime() - 1 * 24 * 60 * 60 * 1000 || time.getTime() > new Date(_this.endTime).getTime()
          }
        }
      },
      // 车辆初始化方法
      initMethod () {
        // 初始化查询表单
        this.dataForm.keyWords = ''
        this.dataForm.day = this.day
        this.dataForm.type = 'V'
        // console.info('this.startDate------------------>lai ', this.startDate)
        // console.info('new Date(this.startTime)------------------>lai ', new Date(this.startTime.replace(/-/g, '/')))
        // console.info('this.endDate------------------>lai ', this.endDate)
        // console.info('this.endTime------------------>lai ', this.endTime)
        if (this.startDate === new Date(this.startTime.replace(/-/g, '/')) && this.endDate === this.endTime) {
          this.dataForm.startTime = this.startDate
          this.dataForm.endTime = this.endDate
        } else {
          this.startDate = this.startTime
          this.endDate = this.endTime
          this.dataForm.startTime = this.startDate
          this.dataForm.endTime = this.endDate
        }
        this.dataForm.siteId = this.siteId
        let dateS = new Date(this.dataForm.startTime.replace(/-/g, '/'))
        console.info('dateS------------->', dateS)
        let dateE = new Date(this.dataForm.endTime.replace(/-/g, '/'))
        console.info('dateE------------->', dateE)
        this.dataForm.startTime = dateS.getFullYear() + '-' + (dateS.getMonth() + 1) + '-' + dateS.getDate() + ' ' + dateS.getHours() + ':' + dateS.getMinutes() + ':' + dateS.getSeconds();
        this.dataForm.endTime = dateE.getFullYear() + '-' + (dateE.getMonth() + 1) + '-' + dateE.getDate() + ' ' + dateE.getHours() + ':' + dateE.getMinutes() + ':' + dateE.getSeconds();
        // 查询话查询日历参数
        this.schedulingDiv.id = ''
        this.schedulingDiv.roomCnAbbr = ''
        this.dataForm.queryType = '0'
        // 主页面查询
        this.queryVehicle()
        // 查询日历
        this.dataUpdate()
      },
      query(){
        this.dataForm.queryType = '0'
        this.queryVehicle()
      },
      // 查询
      queryVehicle () {
        // if (this.dataForm.startTime < this.startDate || this.dataForm.startTime > this.endDate) {
        //   // this.$message.error('选择时间应在开始时间和结束时间之内')
        //   this.$message({
        //     message: '选择时间应在开始时间和结束时间之内!',
        //     type: 'error',
        //     duration: 2000
        //   })
        //   return false
        // }
        // if (this.dataForm.endTime < this.startDate || this.dataForm.endTime > this.endDate) {
        //   // this.$message.error('选择时间应在开始时间和结束时间之内')
        //   this.$message({
        //     message: '选择时间应在开始时间和结束时间之内!',
        //     type: 'error',
        //     duration: 2000
        //   })
        //   return false
        // }
        if (new Date(this.dataForm.startTime.replace(/-/g, '/')) > new Date(this.dataForm.endTime.replace(/-/g, '/'))) {
          // 清空勾选
          // this.$message.error('开始时间不能大于结束时间')
          this.$message({
            message: '开始时间不能大于结束时间!',
            type: 'error',
            duration: 2000
          })
          return
        }
        if(this.dataForm.queryType === '0'){
          this.dataForm.ablePage = 1
          this.dataForm.allPage = 1
          this.dataForm.enaPage = 1
        }
        // console.info('this.dataForm.startTime开始时间--------------->', this.dataForm.startTime)
        // console.info('this.dataForm.endTime结束时间--------------->', this.dataForm.endTime)
        console.info('this.dataForm车辆查询---------------->', this.dataForm)
        this.dataListLoading = true
        let url = '/rm/resourceSelect/queryVehicleResult'
        this.$request.post(
                url, this.dataForm
        ).then((res, total, code, data) => {
          // console.info('total----------------->', total)
          // console.info('data----------------->', data.data)
          if(this.dataForm.queryType === '0'){
            this.ableVehicleList = data.data.ableVehicleList.records
            this.allocateVehicleList = data.data.allocateVehicleList.records
            this.enableVehicleList = data.data.enableVehicleList.records
            this.ableVehicleListTotal = parseInt(data.data.ableVehicleList.total, 10)
            this.allocateVehicleListTotal = parseInt(data.data.allocateVehicleList.total, 10)
            this.enableVehicleListTotal = parseInt(data.data.enableVehicleList.total, 10)
          }else if(this.dataForm.queryType === '1'){
            this.ableVehicleList = data.data.ableVehicleList.records
            this.ableVehicleListTotal = parseInt(data.data.ableVehicleList.total, 10)
          }else if(this.dataForm.queryType === '2'){
            this.allocateVehicleList = data.data.allocateVehicleList.records
            this.allocateVehicleListTotal = parseInt(data.data.allocateVehicleList.total, 10)
          }else if(this.dataForm.queryType === '3'){
            this.enableVehicleList = data.data.enableVehicleList.records
            this.enableVehicleListTotal = parseInt(data.data.enableVehicleList.total, 10)
          }
          this.dataListLoading = false
        }).catch(() => {
          this.dataListLoading = false
        })
      },
      // 单选
      selectRedio: function selectRedio (selection, row) {
        if (this.$refs.coursePlanTable.selection.length > 1) {
          this.$refs.coursePlanTable.clearSelection()
          this.$refs.coursePlanTable.toggleRowSelection(row)
        }
      },
      // 确认
      onOk: function () {
        let select = this.$refs.coursePlanTable.selection
        if (select.length <= 0) {
          this.$message.warning(this.$t('res.rela.selectCheck'))
          return false
        }
        if (new Date(this.dataForm.endTime.replace(/-/g, '/')) < new Date(this.dataForm.startTime.replace(/-/g, '/'))) {
          // this.$message.error('结束时间必须大于开始时间')
          this.$message({
            message: '结束时间必须大于开始时间!',
            type: 'error',
            duration: 2000
          })
          return false
        }
        let _this = this
        _this.$emit('onOk', select)
        this.dataForm = {
          keyWords: '',
          siteId: '',
          startTime: '',
          endTime: '',
          type: 'V',
          queryType : '0',
          ablePage: 1, // 当前页码
          ableLimit: 10, // 每页数
          allPage: 1, // 当前页码
          allLimit: 10, // 每页数
          enaPage: 1, // 当前页码
          enaLimit: 10, // 每页数
        }
      },
      // 查询培训师选中
      addVehicleClass (row) {
        // if (this.dataForm.startTime < this.startDate || this.dataForm.startTime > this.endDate) {
        //   // this.$message.error('选择时间应在开始时间和结束时间之内')
        //   this.$message({
        //     message: '选择时间应在开始时间和结束时间之内!',
        //     type: 'error',
        //     duration: 2000
        //   })
        //   return false
        // }
        // if (this.dataForm.endTime < this.startDate || this.dataForm.endTime > this.endDate) {
        //   // this.$message.error('选择时间应在开始时间和结束时间之内')
        //   this.$message({
        //     message: '选择时间应在开始时间和结束时间之内!',
        //     type: 'error',
        //     duration: 2000
        //   })
        //   return false
        // }
        if (!this.dataForm.startTime || !this.dataForm.endTime) {
          // 清空勾选
          // this.$message.error('请选择开始和结束时间')
          this.$message({
            message: '请选择开始和结束时间!',
            type: 'error',
            duration: 2000
          })
          return
        }
        if (!this.dataForm.startTime || !this.dataForm.endTime) {
          // 清空勾选
          // this.$message.warning('请选择开始和结束时间')
          this.$message({
            message: '请选择开始和结束时间!',
            type: 'error',
            duration: 2000
          })
          return
        }
        if (this.dataForm.startTime > this.dataForm.endTime) {
          // 清空勾选
          // this.$message.warning('开始时间不能大于结束时间')
          this.$message({
            message: '开始时间不能大于结束时间!',
            type: 'error',
            duration: 2000
          })
          return
        }
        if (!this.dataForm.day) {
          // this.$message.warning('请填写实际培训天数')
          this.$message({
            message: '请填写实际培训天数!',
            type: 'error',
            duration: 2000
          })
          return
        }
        let startTime = this.dataForm.startTime.substr(0, 10)
        let endTime = this.dataForm.endTime.substr(0, 10)
        let t1 = new Date(Date.parse(startTime.replace(/-/g, '/')))
        let t2 = new Date(Date.parse(endTime.replace(/-/g, '/')))
        let iDays = parseInt(Math.abs(t2.getTime() - t1.getTime()) / 1000 / 60 / 60 / 24, 10)
        if (iDays + 1 < this.dataForm.day) {
          // this.$message.warning('实际培训天数超过了开始时间和结束时间的范围!')
          this.$message({
            message: '实际培训天数超过了开始时间和结束时间的范围!',
            type: 'error',
            duration: 2000
          })
          return
        }
        // let time = (this.dataForm.endTime.getTime() - this.dataForm.startTime.getTime()) / (60 * 60 * 1000 * 24)// 天
        let param = {
          vehicleId: row.id,
          chassisNo: row.chassisNo,
          dateS: this.dataForm.startTime,
          dateE: this.dataForm.endTime,
          days: this.dataForm.day,
          vehicleClass: row.vehicleClass,
          vehicleBrand: row.brand
        }

        if (row) {
          // 广播通知
          this.$eventHub.$emit('select_vehicle_wxl', param)
        }
      },
      Update (row) {
        if (!this.dataForm.startTime || !this.dataForm.endTime) {
          // 清空勾选
          // this.$message.warning('请选择开始和结束时间')
          this.$message({
            message: '请选择开始和结束时间!',
            type: 'error',
            duration: 2000
          })
          return
        }
        if (row) {
          this.schedulingDiv.id = row.id
          this.schedulingDiv.roomCnAbbr = row.chassisNo
          this.dataSelectForm = this.dataForm
          // 广播通知
          this.$eventHub.$emit('select_vehicleUpdate_wxl', this.schedulingDiv, this.dataForm)
        }
      },
      dataUpdate () {
        // if (this.dataForm.startTime < this.startDate || this.dataForm.startTime > this.endDate) {
        //   // this.$message.error('选择时间应在开始时间和结束时间之内')
        //   this.$message({
        //     message: '选择时间应在开始时间和结束时间之内!',
        //     type: 'error',
        //     duration: 2000
        //   })
        //   return false
        // }
        // if (this.dataForm.endTime < this.startDate || this.dataForm.endTime > this.endDate) {
        //   // this.$message.error('选择时间应在开始时间和结束时间之内')
        //   this.$message({
        //     message: '选择时间应在开始时间和结束时间之内!',
        //     type: 'error',
        //     duration: 2000
        //   })
        //   return false
        // }
        if (new Date(this.dataForm.endTime.replace(/-/g, '/')) < new Date(this.dataForm.startTime.replace(/-/g, '/'))) {
          // this.$message.error('结束时间必须大于开始时间')
          this.$message({
            message: '结束时间必须大于开始时间!',
            type: 'error',
            duration: 2000
          })
          return false
        }
        if (!this.dataForm.startTime || !this.dataForm.endTime) {
          // 清空勾选
          // this.$message.warning('请选择开始和结束时间')
          return
        }
        this.queryVehicle()
        if (this.schedulingDiv) {
          // 广播通知
          this.$eventHub.$emit('select_vehicleUpdate_wxl', this.schedulingDiv, this.dataForm)
        }
      },
      checkLable(row){
        this.isShowLable = true
        this.checkList = []
        this.$request.get(`/rm/vehicleinfo/info/${row.id}`).then((data) => {
          // 已选择的标签
          this.checkList = data.commLabelVoList ? data.commLabelVoList : []
          // 特殊情况，自己国际化
          const language = VueI18n.locale
          if (language === 'zh-CN') {
            this.checkList.forEach(o => {
              o.labelName = o.labelNameCn
            })
          } else {
            this.checkList.forEach(o => {
              o.labelName = o.labelNameEn
            })
          }
        })
      },
      showLableClose(){
        this.isShowLable = false
      },
      getBussinessType (val) {
        this.dataForm.bussinessTypeId = val
        this.bussinessTypeId = val
      },
      changeCheckedList (array) {
        this.checkList = array
      },
      // 重新勾选业务标签
      fatherMethod () {
        this.checkList = []
        // 已选择的标签
        this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          this.checkList.forEach(o => {
            o.labelName = o.labelNameCn
          })
        } else {
          this.checkList.forEach(o => {
            o.labelName = o.labelNameEn
          })
        }
      },
      // 车辆分类转换
      vehicleClassFormatter (row) {
        return Vue.filter('coverEnum')(row.vehicleClassId, 'vehicleClass')
      },
      // 分页, 每页条数
      ablePageSizeChangeHandle (val) {
        this.dataForm.ablePage = 1
        this.dataForm.ableLimit = val
        this.dataForm.queryType = '1'
        this.queryVehicle()
      },
      // 分页, 当前页
      ablePageCurrentChangeHandle (val) {
        this.dataForm.ablePage = val
        this.dataForm.queryType = '1'
        this.queryVehicle()
      },
      // 分页, 每页条数
      allPageSizeChangeHandle (val) {
        this.dataForm.allPage = 1
        this.dataForm.allLimit = val
        this.dataForm.queryType = '2'
        this.queryVehicle()
      },
      // 分页, 当前页
      allPageCurrentChangeHandle (val) {
        this.dataForm.allPage = val
        this.dataForm.queryType = '2'
        this.queryVehicle()
      },
      // 分页, 每页条数
      enaPageSizeChangeHandle (val) {
        this.dataForm.enaPage = 1
        this.dataForm.enaLimit = val
        this.dataForm.queryType = '3'
        this.queryVehicle()
      },
      // 分页, 当前页
      enaPageCurrentChangeHandle (val) {
        this.dataForm.enaPage = val
        this.dataForm.queryType = '3'
        this.queryVehicle()
      }

    }
  }
</script>
<style>
  .hidden_i_recourse .el-collapse-item__arrow {
    display: none;
  }
  .auth_table {
    border-collapse: collapse;
    width: 100%;
  }
  .show_header .el-table__empty-block {
    display: none;
  }
  .startTime-label .el-form-item__label {
    text-align: center !important;
    font-size: 12px !important;
  }
  .startTime-label .el-input__inner {
    font-size: 12px !important;
    line-height: 27px !important;
  }
  .change_title_background
  > .el-table__header-wrapper
  > .el-table__header
  > thead
  > tr
  > th {
    background: #ebecf0 !important;
    border-right: 1px #dcdee3 solid;
  }
  .removeX >.el-input__suffix {
    display: none;
  }
  /* 隐藏网格的全选按钮 */
.jySelectionAll
  > .el-table__fixed
  > .el-table__fixed-header-wrapper
  > .el-table__header
  > thead
  > tr
  > th
  > .cell
  > label {
  display: none;
}
</style>
